/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/



 
  
  document.addEventListener("DOMContentLoaded", function(){


const newBadge = '<span class="new-icon">NUOVO</span>';
$('a.sliderow__title:contains("SHOP THE LOOK")').append(newBadge)
$('a.sliderow__title:contains("OUTLET")').append(newBadge)


  
  $("body").removeClass("boost-sd__search-widget-init-enabled");

  // Add custom code below this line
    //let html = `<div class="sliderule__wrapper">
    //<button id="loyalty_button" class="sliderow" type="button" data-animates="0" data-animation="drawer-items-fade" data-animation-delay="350" data-animation-duration="500"  aria-haspopup="true" aria-expanded="false" >
    //    <span class="sliderow__title" style="color: #ff6907; font-weight: 600">
    //        PIANO FEDELTÀ
    //        <span class="sliderule__chevron--right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 24 24"><path d="M6 12h12.5m0 0-6-6m6 6-6 6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg><span class="visually-hidden">Mostra menu</span>
    //        </span>
    //    </span>
    //</button></div>`;
    
    $('.appstle-loyalty-button').hide();
    //$(".sliderule__wrapper").first().prepend(html);
    var $heroButton = $('.hero__button').has('span:contains("Piano Fedeltà")');

    $heroButton.click(() => {
        $(".header__mobile__hamburger").click();
        $("#appstle-loyalty-button").click();
    });

  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})
